import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

import type { ModelBillLite, OrganizationModel } from '@app/api/Bills';
import { ADD_PAYMENT_DOCUMENTS_PATH } from '@app/constants';
import { divideAmount } from '@app/utils';

import type { ColumnsType } from 'antd/es/table';

export const getColumns = ({}) => {
  const columns: ColumnsType<ModelBillLite> = [
    {
      title: 'Название',
      dataIndex: 'Name',
      key: 'Name',
      render: (value: string) => value,
    },
    {
      title: 'Организация',
      dataIndex: 'Organization',
      key: 'Organization',
      width: 140,
      render: (value: OrganizationModel) => {
        return value.Value;
      },
    },
    {
      title: 'Дата создания',
      dataIndex: 'DateCreated',
      key: 'DateCreated',
      render: (value: string) => <>{dayjs(value).format('DD.MM.YYYY')}</>,
    },
    {
      title: 'Сумма',
      dataIndex: 'Amount',
      key: 'Amount',
      render: (value: number) => divideAmount(value),
    },
    {
      title: 'Статус',
      dataIndex: 'Status',
      key: 'Status',
      render: (value: string | null) => value ?? '-',
    },
    {
      title: null,
      key: 'actions',
      dataIndex: 'actions',
      width: 48,
      fixed: 'right',
      render: (_, record) => (
        <Link to={`${ADD_PAYMENT_DOCUMENTS_PATH}?id=${record.Id}`}>
          <Button icon={<EditOutlined />} data-testid="edit-payment-document" />
        </Link>
      ),
    },
  ];

  return columns;
};
